import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';

const storageFolderSchema = z.union([z.literal('Offer'), z.literal('General'), z.literal('Comments')]);

export const filesEndpoints = {
    'POST /files/upload': endpoint({
        description: 'Uploads a file to the server',
        pathParams: z.undefined(),
        queryParams: z.object({
            type: storageFolderSchema,
        }),
        requestBody: z.instanceof(FormData),
        responseBody: z.object({ file_path: z.string() }),
    }),

    'GET /files/download/:filePath': endpoint({
        description: 'Downloads a file from the server',
        pathParams: z.object({
            filePath: z.string(),
        }),
        queryParams: z.object({
            type: storageFolderSchema,
        }),
        requestBody: z.undefined(),
        responseBody: z.object({ download_url: z.string() }),
    }),
};
